import React from 'react';
import { TgJobProvider } from './tg-job.provider';
import { TgJob } from './tg-job.view';

type TgJobFeatureProps = {
   captchaKey: string | null;
};

export const TgJobFeature: React.FC<TgJobFeatureProps> = () => {
   return (
      <TgJobProvider>
         <TgJob />
      </TgJobProvider>
   );
};
